import { render, staticRenderFns } from "./RecapSearch.component.vue?vue&type=template&id=643fb684&"
import script from "./RecapSearch.component.vue?vue&type=script&lang=js&"
export * from "./RecapSearch.component.vue?vue&type=script&lang=js&"
import style0 from "./RecapSearch.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports